import React from 'react';

import WidgetInput from './WidgetInput';
import WidgetGroupInput from './WidgetGroupInput';

import BookprocessWidgetProps from './interfaces/BookprocessWidgetPropsInterface';
import PropsGroup from './interfaces/PropsGroupInterface';

interface BookprocessImageProps extends React.HTMLProps<HTMLImageElement> {
    src: string;
}

export default class WidgetGroup extends WidgetInput<PropsGroup> {
    render() {
        let wrappers: Array<React.ReactElement<BookprocessWidgetProps | BookprocessImageProps>> =
            this.props.inputs.map(props => {
                return React.createElement(WidgetGroupInput, {
                    ...props,
                    key: props.id,
                    settings: this.props.settings,
                    handleChange: this.props.handleChange,
                    getStateValue: this.props.getStateValue,
                });
            });

        let classNames = ['subgroupWrapper'];
        if (this.props.className) {
            classNames.push(this.props.className);
        }

        if (this.props.recrastype) {
            classNames.push(`recras-${this.props.recrastype.replace('.', '_')}`);
        }

        if (this.props?.settings?.autoAmount) {
            classNames.push('auto-amount');
        }

        return React.createElement('div', { className: classNames.join(' ') }, wrappers);
    }
}
